export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6299.b52b191c.jpg";